/**
 * Where the control plane is, from the browser's point of view.
 *
 * An empty `VITE_API_URL` is the production value, not a misconfiguration:
 * nginx forwards `/api/*` to the backend on the app's own hostname, so
 * cookies stay first-party and CORS never applies. The client then has to
 * resolve against the visible origin itself, because oRPC's `RPCLink` does
 * `new URL(path, this.url)` and throws on a relative base — a failure that
 * used to surface as every RPC call dying with "Invalid URL".
 *
 * `globalThis.location` rather than `window.location`: the same resolution
 * runs in the main thread, a worker and a service worker.
 */
export function resolveApiOrigin(viteApiUrl) {
    if (viteApiUrl)
        return viteApiUrl;
    return globalThis.location.origin;
}
/** The oRPC mount for the user app, on whichever origin `resolveApiOrigin` picks. */
export function resolveOrpcUrl(viteApiUrl) {
    return `${resolveApiOrigin(viteApiUrl)}/api/user-app`;
}
/**
 * better-auth's base URL. Undefined — let the library default — where there
 * is no window at all, which is the one case its own resolution handles
 * better than ours.
 */
export function resolveAuthBaseUrl(viteApiUrl) {
    if (viteApiUrl)
        return viteApiUrl;
    return typeof window !== "undefined" ? window.location.origin : undefined;
}
//# sourceMappingURL=api_base_url.js.map